import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import { isDefined, functor, getMALabel } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

class KeltnerTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const { onClick, displayFormat, yAccessor, options, textFill, labelFill } =
      this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);

    let top = "n/a";
    let middle = "n/a";
    let bottom = "n/a";

    if (isDefined(currentItem) && isDefined(yAccessor(currentItem))) {
      const item = yAccessor(currentItem);
      if (item) {
        if (isDefined(item.top)) top = displayFormat(item.top);
        if (isDefined(item.middle)) middle = displayFormat(item.middle);
        if (isDefined(item.bottom)) bottom = displayFormat(item.bottom);
      }
    }

    const origin = functor(this.props.origin);
    const [x, y] = origin(width, height);

    const { sourcePath, period, multiplier, movingAverageType } = options;
    // Get MA type label from centralized utility
    const maLabel = getMALabel(movingAverageType);
    const tooltipLabel = `Keltner(${sourcePath}, ${period}, ${multiplier}, ${maLabel}): `;
    const tooltipValue = `${top}, ${middle}, ${bottom}`;

    return (
      <g
        transform={`translate(${x}, ${y})`}
        className={this.props.className}
        onClick={onClick}
        data-evo-id="tooltip-keltner"
      >
        <ToolTipText
          x={0}
          y={0}
          fontFamily={this.props.fontFamily}
          fontSize={this.props.fontSize}
        >
          <ToolTipTSpanLabel fill={labelFill}>{tooltipLabel}</ToolTipTSpanLabel>
          <tspan fill={textFill}>{tooltipValue}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

KeltnerTooltip.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  displayFormat: PropTypes.func.isRequired,
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  onClick: PropTypes.func,
  options: PropTypes.shape({
    sourcePath: PropTypes.string.isRequired,
    period: PropTypes.number.isRequired,
    multiplier: PropTypes.number.isRequired,
    movingAverageType: PropTypes.string.isRequired,
  }).isRequired,
  textFill: PropTypes.string,
  labelFill: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
};

KeltnerTooltip.defaultProps = {
  className: "react-stockcharts-tooltip react-stockcharts-keltner-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  origin: [0, 10],
};

export default KeltnerTooltip;
